/**
 * ChatInput — the AI Assistant's composer.
 *
 * A thin wrapper over the shared `ChatComposer`; everything here is what the
 * Assistant surface adds on top of it (its store, the context scope menu, and
 * the quoted-passage chip from the document panel).
 */

import { ChatComposer } from "@/components/chat/ChatComposer"
import { ContextScopeMenu } from "@/components/assistant/ContextScopeMenu"
import { useAssistantStore } from "@/stores/assistant-store"
import { DRAFT_STASH_KEYS } from "@/lib/draft-stash"

interface ChatInputProps {
  /** `card` on a tinted panel (the assistant dock). */
  inputSurface?: 'muted' | 'card'
  isVisible?: boolean
}

export function ChatInput({ inputSurface = 'muted', isVisible = true }: ChatInputProps = {}) {
  const {
    sendMessage,
    cancelStream,
    isLoading,
    isStreaming,
    panelSelection,
    setPanelSelection,
  } = useAssistantStore()

  return (
    <ChatComposer
      sendMessage={sendMessage}
      cancelStream={cancelStream}
      isLoading={isLoading}
      isStreaming={isStreaming}
      label="Message the AI assistant"
      placeholder="Ask anything"
      selectionPlaceholder="What do you want to change?"
      draftStashKey={DRAFT_STASH_KEYS.assistant}
      scopeControl={<ContextScopeMenu />}
      panelSelection={panelSelection}
      onClearPanelSelection={() => setPanelSelection(null)}
      inputSurface={inputSurface}
      isVisible={isVisible}
    />
  )
}
